<template>
  <FormRadioGroupField :label="prompt" :options="{'Yes': true, 'No': false}" v-model="enabled" @change="onInput()"/>

  <div v-if="enabled">
    <FormTextField label="Full Name *" v-model="representative.name" trimmed autoFocus @change="onInput()"/>
    <FormTextField label="Phone" v-model="representative.phone" trimmed @change="onInput()"/>
    
    <Columns>
        <FormTextField label="Building Number / Name *" v-model="representative.address!.number" @change="onInput()"/>
        <FormTextField label="Street *" v-model="representative.address!.street" trimmed @change="onInput()"/>
    </Columns>

    <Columns>
        <FormTextField label="City *" v-model="representative.address!.city" trimmed @change="onInput()"/>
        <FormSelectField label="State *" :options="ProfileTypes.StateNotUnknown" allowNullSelection v-model="representative.address!.state" @update:modelValue="onInput()"/>
    </Columns>

    <FormTextField label="Preferred Language *" v-model="representative.preferredLanguage" trimmed @change="onInput()"/>
    <FormCheckboxField boxLabel="This person requires an interpreter" v-model="representative.interpreterNeeded" @change="onInput()"/>

    <HalfColumn>
      <SignaturePadField style="flex-grow: 1.8" class="mt-5" ref="signaturePad" label="Please have your authorized representative sign here"/>
    </HalfColumn>
  </div>

</template>

<script lang="ts" setup>
import { GeorgiaDfcsBenefits, ProfileTypes } from "@minicity/core";
import { onMounted, ref, watch } from "vue";
import { DeepPartial } from "@/core/utils";
import SignaturePadField from "@/components/SignaturePadField.vue";

const props = defineProps<{
  modelValue?: DeepPartial<GeorgiaDfcsBenefits.AuthorizedRepresentative>|null,
  prompt: string,
}>();

const enabled = ref<boolean|null>(null);
const representative = ref<DeepPartial<GeorgiaDfcsBenefits.AuthorizedRepresentative>>({
  name:"",
  phone:"",
  address: {

  },
  preferredLanguage:"English",
  interpreterNeeded: false
});

const signaturePad = ref(null);

// Event for two-way binding
const emit = defineEmits(['update:modelValue']);

const onInput = () => {
  console.log("oi", enabled.value, representative.value.address?.state);
  if (enabled.value === true) {
    if (getValidationErrors()) { 
      emit('update:modelValue', undefined);
    } else {
      emit('update:modelValue', {...representative.value});
    }
  } else if (enabled.value === false) {
    emit('update:modelValue', null);
  } else {
    emit('update:modelValue', undefined);
  }
};

onMounted(() => {
  if (props.modelValue === undefined) {
    // Nothing
  } else if (props.modelValue === null) {
    // No representative
    enabled.value = false;
  } else {
    // Representative
    enabled.value = true;
    representative.value = {...props.modelValue};
  }
});

const getSignatureData = () => {
  const pad = signaturePad.value as any;
  console.log("PAD", pad);
  return pad.isSignatureEmpty() ? undefined : pad.getSignatureData() as string;
}

const getValidationErrors = () => {
  if (!enabled.value) return undefined;
  if (representative.value.name!.length == 0) return ["Please enter the representative's name"];
  if (representative.value.address!.number?.length == 0) return ["Please enter the representative's building number / name"];
  if (representative.value.address!.street?.length == 0) return ["Please enter the representative's street"];
  if (representative.value.address!.city?.length == 0) return ["Please enter the representative's city"];
  if (!representative.value.address!.state) return ["Please select the representative's state"];
  if (representative.value.preferredLanguage!.length == 0) return ["Please enter the representative's preferred language"];
}

defineExpose({
    getSignatureData,
    getValidationErrors,
});
</script>

<style scoped>
</style>